import React, { useState, useEffect, useRef } from "react";
import { MdOutlineCancel } from "react-icons/md";
import { CiEdit } from "react-icons/ci";
import { MdDelete } from "react-icons/md";
import { CiSearch } from "react-icons/ci";
import { FaPlus } from "react-icons/fa6";
import { HiOutlineDotsVertical } from "react-icons/hi";
import toast from "react-hot-toast";

const User = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [role, setRole] = useState("");
  const [phone, setPhone] = useState("");
  const [destination, setDestination] = useState("");
  const [editId, setEditId] = useState(null);
  const [activeDropdown, setActiveDropdown] = useState(null);
  const [search, setSearch] = useState("");
  const dropdownRef = useRef();

  const [users, setUsers] = useState([
    {
      id: 1,
      name: "John",
      email: "john@example.com",
      role: "Dev",
      destination: "USA",
      phone: 9876543,
    },
    {
      id: 2,
      name: "Alice",
      email: "alice@example.com",
      role: "Manager",
      destination: "UK",
      phone: 9876543,
    },
  ]);

  const toggleDropdown = (id) => {
    setActiveDropdown((prevId) => (prevId === id ? null : id));
  };

  const handleEdit = (user) => {
    setName(user.name);
    setEmail(user.email);
    setRole(user.role);
    setDestination(user.destination);
    setPhone(user.phone);
    setEditId(user.id);
    setMenuOpen(true);
    setActiveDropdown(null);
  };

  const handleDelete = (id) => {
    setUsers((prevUsers) => prevUsers.filter((user) => user.id !== id));
    toast.success("User deleted successfully");
    setActiveDropdown(null);
  };

  const handleSubmit = () => {
    if (!name || !email || !role || !destination || !phone) {
      toast.error("All fields are required");
      return;
    }

    if (editId !== null) {
      setUsers((prevUsers) =>
        prevUsers.map((user) =>
          user.id === editId
            ? { ...user, name, email, role, destination, phone }
            : user
        )
      );
      toast.success("User updated successfully");
    } else {
      const newUser = {
        id: Date.now(),
        name,
        email,
        role,
        destination,
        phone,
      };
      setUsers((prevUsers) => [newUser, ...prevUsers]);
      toast.success("User added successfully");
    }

    setMenuOpen(false);
    setEditId(null);
    setName("");
    setEmail("");
    setRole("");
    setDestination("");
    setPhone("");
  };

  const handleClickOutside = (event) => {
    if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
      setActiveDropdown(null);
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return (
    <div className="ml-60 px-10 mt-[5%]">
      <div className="flex justify-between">
        <div className="relative w-[400px]">
          <input
            type="text"
            placeholder="Search People"
            className="rounded-md px-3 py-2 border border-black w-full pl-10 text-black font-semibold"
            value={search}
            onChange={(e) => setSearch(e.target.value)}
          />
          <CiSearch fontSize={20} className="absolute top-3 left-3 text-black font-medium" />
        </div>
        <div className="flex justify-end">
          <button
            className="rounded-md px-6 py-2 border bg-black text-white font-bold flex items-center gap-2"
            onClick={() => setMenuOpen(true)}
          >
            <FaPlus /> Add User
          </button>
        </div>
      </div>

      <table className="w-full mt-10 rounded-lg overflow-hidden bg-white border">
        <thead>
          <tr className="text-left text-sm text-gray-500 font-semibold border-b">
            <th className="py-3 px-4">S.No</th>
            <th className="py-3 px-4">Name</th>
            <th className="py-3 px-4">Email</th>
            <th className="py-3 px-4">Role</th>
            <th className="py-3 px-4">Destination</th>
            <th className="py-3 px-4">Phone</th>
            <th className="py-3 px-4">Action</th>
          </tr>
        </thead>
        <tbody>
          {users
            .filter((user) => user.name.toLowerCase().includes(search.toLowerCase()))
            .map((user, i) => (
              <tr key={user.id} className="hover:bg-gray-100 transition border-b">
                <td className="py-3 px-4 text-sm text-gray-700 font-medium">{i + 1}</td>
                <td className="py-3 px-4 text-sm text-gray-700 font-medium">{user.name}</td>
                <td className="py-3 px-4 text-sm text-gray-700 font-medium">{user.email}</td>
                <td className="py-3 px-4 text-sm text-gray-700 font-medium">{user.role}</td>
                <td className="py-3 px-4 text-sm text-gray-700 font-medium">{user.destination}</td>
                <td className="py-3 px-4 text-sm text-gray-700 font-medium">{user.phone}</td>
                <td className="py-3 px-4 text-sm text-gray-700 font-medium relative">
                  <div className="flex gap-3">
                    <HiOutlineDotsVertical fontSize={20} onClick={() => toggleDropdown(user.id)} />
                    {activeDropdown === user.id && (
                      <div
                        ref={dropdownRef}
                        className="absolute top-6 right-0 z-10 flex flex-col bg-white shadow-md rounded-md border p-2 w-28"
                      >
                        <button
                          className="flex items-center gap-2 text-sm text-gray-700 hover:text-green-600 hover:bg-gray-100 rounded px-2 py-1"
                          onClick={() => handleEdit(user)}
                        >
                          <CiEdit fontSize={18} /> Edit
                        </button>
                        <button
                          className="flex items-center gap-2 text-sm text-gray-700 hover:text-red-600 hover:bg-gray-100 rounded px-2 py-1 mt-1"
                          onClick={() => handleDelete(user.id)}
                        >
                          <MdDelete fontSize={18} /> Delete
                        </button>
                      </div>
                    )}
                  </div>
                </td>
              </tr>
            ))}
        </tbody>
      </table>

      {menuOpen && (
        <div className="fixed top-0 left-0 w-full h-full bg-black bg-opacity-30 flex justify-center items-center z-50">
          <div className="w-[700px] bg-white p-6 text-black rounded-lg shadow-lg">
            <div className="flex justify-end">
              <button
                onClick={() => {
                  setMenuOpen(false);
                  setEditId(null);
                  setName("");
                  setEmail("");
                  setRole("");
                  setDestination("");
                  setPhone("");
                }}
              >
                <MdOutlineCancel fontSize={24} className="text-red-600 hover:text-red-800" />
              </button>
            </div>

            <h2 className="text-lg font-semibold mb-4">
              {editId !== null ? "Edit User" : "Add User"}
            </h2>

            <div className="grid grid-cols-2 gap-4">
              <div>
                <label className="block mb-1 text-sm font-medium text-black">Name</label>
                <input
                  type="text"
                  placeholder="Enter Name"
                  className="w-full rounded-md px-3 py-2 border border-gray-300"
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                />
              </div>
              <div>
                <label className="block mb-1 text-sm font-medium text-black">Email</label>
                <input
                  type="email"
                  placeholder="Enter Email"
                  className="w-full rounded-md px-3 py-2 border border-gray-300"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                />
              </div>
              <div>
                <label className="block mb-1 text-sm font-medium text-black">Role</label>
                <input
                  type="text"
                  placeholder="Enter Role"
                  className="w-full rounded-md px-3 py-2 border border-gray-300"
                  value={role}
                  onChange={(e) => setRole(e.target.value)}
                />
              </div>
              <div>
                <label className="block mb-1 text-sm font-medium text-black">Destination</label>
                <input
                  type="text"
                  placeholder="Enter Destination"
                  className="w-full rounded-md px-3 py-2 border border-gray-300"
                  value={destination}
                  onChange={(e) => setDestination(e.target.value)}
                />
              </div>
              <div>
                <label className="block mb-1 text-sm font-medium text-black">Phone</label>
                <input
                  type="number"
                  placeholder="Enter Phone Number"
                  className="w-full rounded-md px-3 py-2 border border-gray-300"
                  value={phone}
                  onChange={(e) => setPhone(e.target.value)}
                />
              </div>
            </div>

            <div className="mt-10 w-full">
              <button
                className="bg-black text-white px-4 py-2 rounded-md w-full font-semibold"
                onClick={handleSubmit}
              >
                {editId !== null ? "Update" : "Submit"}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default User;
